import { render, staticRenderFns } from "./AdditionalOrder.vue?vue&type=template&id=ca9c4ec0&"
import script from "./AdditionalOrder.vue?vue&type=script&lang=js&"
export * from "./AdditionalOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports